module.exports = "<span (click)=\"pulsado($event)\" class='divIcon'>\r\n        <i class=\"material-icons material-icons--outline\">info</i>\r\n</span>\r\n<div class='divMessage'>\r\n        <p-growl [(value)] = \"msgs\" closable=\"true\"></p-growl>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/graficas/infoDash/infoDash.component.html
// module id = ../../../../../src/app/componentes/graficas/infoDash/infoDash.component.html
// module chunks = main